import React, { useEffect } from 'react';
import { SubmissionError } from 'redux-form';
import { login } from '../../../../actions/authenticationActions';
import LoginEmailForm from './LoginEmailForm';
import { ROUTE_FORGOT_PASSWORD } from '../../../../constants/Routes';
import Notification, {
	NOTIFICATION_TYPE_INFORMATION,
	NOTIFICATION_TYPE_SUCCESS,
} from '../../../common/notification/Notification';
import {
	ACCOUNT_DISABLED,
	ACCOUNT_LOCKED,
	WRONG_PASSWORD,
	ACCOUNT_FORCED_PWD_RESET,
} from '../../../../constants/ErrorTypes';
import { isNotificationActive } from '../../../../helpers/state';
import {
	LOGOUT_ALL_DEVICES_SUCCESS,
	EMAIL_ALREADY_EXISTS_NOTIFICATION,
} from '../../../../constants/Notifications';
import { setCustomVariable } from '../../../..//helpers/usabilla';
import { hideNotification } from '../../../../actions/notificationActions';
import {
	NOTIFICATION_LOGOUT_ALL_DEVICES_SUCCESS,
	NOTIFICATION_EMAIL_ALREADY_EXISTS,
	LOGIN,
} from '../../../../constants/Copy';
import '../Login.scss';
import { useDispatch, useSelector } from 'react-redux';
import { PARAM_NAMES } from '../../../../constants/Checkout';
import useSearchParams from '../../../../hooks/useSearchParams';
import { initiateTrackStructEvent } from '../../../analytics/Snowplow';
import {
	EVT_LOGIN,
	EVT_ERROR,
	EVT_FUNNEL,
	EVT_ELEMENT_INTERACTION,
	EVT_ELEMENT_TYPE_BUTTON,
	EVT_LOGIN_SUBMIT,
	EVT_ELEMENT_STYLE_PRIMARY,
} from '../../../../constants/SnowplowEvents';
import { EMAIL_ALREADY_EXISTS } from '../../../../constants/ErrorTypes';

export const LoginEmailContainer = ({ history }) => {
	const { XLTOVL } = PARAM_NAMES;
	const dispatch = useDispatch();
	const { getSearchParam } = useSearchParams();

	const initialValues = useSelector((state) => {
		return { email: state.authentication.email };
	});

	const isLogoutAllDevicesSuccess = useSelector((state) =>
		isNotificationActive(state, LOGOUT_ALL_DEVICES_SUCCESS)
	);
	const isEmailAlreadyExists = useSelector((state) =>
		isNotificationActive(state, EMAIL_ALREADY_EXISTS_NOTIFICATION)
	);

	useEffect(() => {
		if (isEmailAlreadyExists) {
			initiateTrackStructEvent({
				category: EVT_FUNNEL,
				action: EVT_ERROR,
				label: EMAIL_ALREADY_EXISTS,
			});
		}
	}, [isEmailAlreadyExists]);

	useEffect(() => {
		if (isLogoutAllDevicesSuccess) {
			setCustomVariable('logoutAllDevices');
		}
	}, [isLogoutAllDevicesSuccess]);

	useEffect(() => {
		return () => {
			dispatch(hideNotification(LOGOUT_ALL_DEVICES_SUCCESS));
			dispatch(hideNotification(EMAIL_ALREADY_EXISTS_NOTIFICATION));
		};
	}, [dispatch]);

	return (
		<>
			<Notification
				title={NOTIFICATION_LOGOUT_ALL_DEVICES_SUCCESS.TITLE}
				description={NOTIFICATION_LOGOUT_ALL_DEVICES_SUCCESS.DESCRIPTION}
				type={NOTIFICATION_TYPE_SUCCESS}
				visible={isLogoutAllDevicesSuccess}
				className="notification--top-offset"
				button={{
					onClick: () => dispatch(hideNotification(LOGOUT_ALL_DEVICES_SUCCESS)),
					text: NOTIFICATION_LOGOUT_ALL_DEVICES_SUCCESS.BUTTON,
				}}
			/>
			<Notification
				title={NOTIFICATION_EMAIL_ALREADY_EXISTS.TITLE}
				description={NOTIFICATION_EMAIL_ALREADY_EXISTS.DESCRIPTION}
				type={NOTIFICATION_TYPE_INFORMATION}
				visible={isEmailAlreadyExists}
				className="notification--top-offset"
				button={{
					onClick: () => dispatch(hideNotification(EMAIL_ALREADY_EXISTS_NOTIFICATION)),
					text: NOTIFICATION_EMAIL_ALREADY_EXISTS.BUTTON,
				}}
			/>
			<LoginEmailForm
				initialValues={initialValues}
				onSocialLogin={changePassword}
				onSubmit={handleSubmit}
				history
				showMigratedTitleAndHideRegisterLink={!!getSearchParam(XLTOVL)}
			/>
		</>
	);

	async function handleSubmit({ email, password }) {
		await initiateTrackStructEvent({
			category: EVT_LOGIN,
			action: EVT_LOGIN_SUBMIT,
			label: LOGIN,
			rtlElementContext: {
				elementInteraction: EVT_ELEMENT_INTERACTION,
				elementGroup: EVT_LOGIN,
				elementType: EVT_ELEMENT_TYPE_BUTTON,
				elementName: EVT_LOGIN,
				elementLabel: LOGIN,
				elementStyle: EVT_ELEMENT_STYLE_PRIMARY,
			},
		});
		return dispatch(login({ email, password: password || '' })).catch(({ message }) => {
			initiateTrackStructEvent({
				category: EVT_LOGIN,
				action: EVT_ERROR,
				label: message,
			});
			if (message === WRONG_PASSWORD || message === ACCOUNT_FORCED_PWD_RESET) {
				throw new SubmissionError({ password: message });
			}

			if (message === ACCOUNT_DISABLED || message === ACCOUNT_LOCKED) {
				throw new SubmissionError({ email: message });
			}
		});
	}

	function changePassword() {
		history.push(ROUTE_FORGOT_PASSWORD);
	}
};
